var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("logos")))]),
              _c(
                "w-card-content",
                [
                  _c("app-file-upload", {
                    attrs: {
                      label: _vm.$ct("upload"),
                      sending: _vm.sending,
                      "allowed-extensions": _vm.allowedExtensions,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onFileInput($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-list",
                _vm._l(_vm.allImages, function (img, i) {
                  return _c(
                    "w-list-item",
                    { key: i },
                    [
                      _c("w-list-item-icon", [
                        _c("span", {
                          staticClass: "thumbnail",
                          style: {
                            backgroundImage: `url(${encodeURI(img.imgUrl)})`,
                          },
                        }),
                      ]),
                      _c(
                        "w-list-item-text",
                        { style: { overflowX: "hidden" } },
                        [_vm._v(" " + _vm._s(img.imgName) + " ")]
                      ),
                      _c(
                        "w-list-item-action",
                        {
                          style: {
                            flexGrow: 0,
                            flexShrink: 0,
                            textAlign: "left",
                          },
                        },
                        [
                          _c("app-select-placement", {
                            style: { flexGrow: 1 },
                            attrs: {
                              layout: _vm.layout,
                              "full-control": _vm.fullControl,
                              "include-none": "",
                            },
                            model: {
                              value: img.placement,
                              callback: function ($$v) {
                                _vm.$set(img, "placement", $$v)
                              },
                              expression: "img.placement",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        { style: { flexShrink: 0, flexGrow: 0 } },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("tooltip.logo-settings"),
                                  expression: "$ct('tooltip.logo-settings')",
                                },
                              ],
                              style: { height: "100%" },
                              attrs: {
                                disabled: _vm.getLogoFromImage(img) == null,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.editImageSettings(img)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "cog" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("tooltip.remove-logo"),
                              expression: "$ct('tooltip.remove-logo')",
                            },
                          ],
                          style: { flexShrink: 0, flexGrow: 0 },
                        },
                        [
                          _c(
                            "w-button",
                            {
                              staticClass: "danger",
                              style: { height: "100%" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeImg(img.awsFile)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.extraSettingsLogo
        ? _c(
            "w-modal",
            { attrs: { value: _vm.extraSettingsLogo != null } },
            [
              _c("app-logo-extra-settings", {
                attrs: { value: _vm.extraSettingsLogo },
                on: {
                  close: function ($event) {
                    _vm.extraSettingsLogo = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }